var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Defaults, Utils, Watch, PropertyConverters } from '@pacem/pacem-core';
import { PacemContenteditableButtonCommandElement, CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE } from './types';
//namespace Pacem.Components.Scaffolding {
let PacemContenteditableHistoryCommandElement = class PacemContenteditableHistoryCommandElement extends PacemContenteditableButtonCommandElement {
    exec() {
        return new Promise((resolve, _) => {
            const history = this.container?.history;
            if (!Utils.isNull(history)) {
                switch (this.command) {
                    case 'redo':
                        if (history.canRedo) {
                            history.redo();
                            resolve();
                        }
                        break;
                    default:
                        if (history.canUndo) {
                            history.undo();
                            resolve();
                        }
                        break;
                }
                this.contentElement.innerHTML = history.current;
            }
        });
    }
    isRelevant(_) {
        return false;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'command':
                this.icon = this.icon || val;
                this.altText = val;
                this.keyboardShortcut = this.keyboardShortcut || ('Ctrl+' + (val === 'redo' ? 'Y' : 'Z'));
                break;
        }
    }
    containerPropertyChangedCallback(name, old, val, first) {
        super.containerPropertyChangedCallback(name, old, val, first);
        const c = this.container, h = c.history;
        if (name === 'range' || name === 'history') {
            // override 'active' state setting
            this.active = !Utils.isNull(c.range) &&
                ((this.command === 'redo' && h?.canRedo) || (this.command !== 'redo' && h?.canUndo));
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String, reflectBack: true })
], PacemContenteditableHistoryCommandElement.prototype, "command", void 0);
PacemContenteditableHistoryCommandElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable-historycommand', shadow: Defaults.USE_SHADOW_ROOT,
        template: CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE
    })
], PacemContenteditableHistoryCommandElement);
export { PacemContenteditableHistoryCommandElement };
